import { mergeSpeciesResources } from '../../../shared/rules/speciesResources.mjs';
import { mergeMonkFocus } from '../../../shared/rules/monk.mjs';
import { mergeRage } from '../../../shared/rules/barbarianRage.mjs';
import { applyFighterResourceUpdate } from '../../../shared/rules/fighter.mjs';
import { applyLayOnHandsUpdate } from '../../../shared/rules/paladin.mjs';
import { applyChannelDivinityUpdate, CHANNEL_DIVINITY_CLASSES } from '../../../shared/rules/channelDivinity.mjs';
import { RANGER_WISDOM_USES } from '../../../shared/rules/ranger.mjs';

// Other class state a rest writes (characterRest.js): uses it restores, and the Wish lockout it starts or counts down.
const REST_CLASS_STATE = Object.freeze({
  bard: ['inspiration'], cleric: ['wishLockout'], druid: ['wildShape'], wizard: ['overchannel'], monk: ['wholenessOfBody'], paladin: ['holyNimbus'], ranger: Object.values(RANGER_WISDOM_USES).map(({ key }) => key), rogue: ['strokeOfLuck'],
});
// Only those keys, so the rest of a class's state keeps what the sheet holds, and a newer revision stays.
const withRestClassState = (character, classState) => Object.entries(REST_CLASS_STATE).reduce((next, [classId, keys]) => {
  const fresh = keys.filter((key) => classState?.[classId]?.[key] && !(Number(next.classState?.[classId]?.[key]?.revision) > Number(classState[classId][key].revision)));
  if (!fresh.length) return next;
  return { ...next, classState: { ...next.classState, [classId]: { ...next.classState?.[classId], ...Object.fromEntries(fresh.map((key) => [key, classState[classId][key]])) } } };
}, character);

export function applyRestSnapshot(character, rest) {
  if (!character || !rest?.fields || !Number.isInteger(rest.revision)
    || rest.revision <= (Number(character.restState?.revision) || 0)) return character;
  const { classState, fighterResources, monkFocus, speciesResources, ...fields } = rest.fields;
  let next = { ...character, ...fields };
  if (classState?.barbarian?.rage) next = mergeRage(next, classState.barbarian.rage);
  // Rest-refilled class pools: Lay On Hands and each class's Channel Divinity (revision-guarded).
  if (classState?.paladin?.layOnHands) next = applyLayOnHandsUpdate(next, classState.paladin.layOnHands);
  for (const classId of Object.keys(CHANNEL_DIVINITY_CLASSES)) if (classState?.[classId]?.channelDivinity) next = applyChannelDivinityUpdate(next, classId, classState[classId].channelDivinity);
  next = withRestClassState(next, classState);
  if (fighterResources) next = applyFighterResourceUpdate(next, fighterResources);
  if (monkFocus) next = mergeMonkFocus(next, monkFocus);
  if (speciesResources) next = mergeSpeciesResources(next, speciesResources);
  return next;
}
